<template>
	<div class="Usercenter">
		<loginheader flagg="1"></loginheader>
		<div class="Usercenter-bg">
			<img src="../../img/User-head.png" alt class="Usercenter-img" />
		</div>
		<div class="Usercenter-concent">
			<div class="Usercenter-con">
				<div class="Usercenter-con-left">
					<router-view />
				</div>
				<div class="Usercenter-con-right">
					<p class="Usercenter-myp">用户中心</p>
					<div class="Usercenter-mydiv">
						<div class="Usercenter-mydiv-head">
							<img src="../../img/xinxi.png" alt class="Usercenter-mydiv-headimg" />
							<router-link to="/Usercenter">
								<p class="Usercenter-mydiv-headp">用户信息</p>
							</router-link>
						</div>
						<div class="Usercenter-mydiv-head1">
							<img src="../../img/shouchang.png" alt class="Usercenter-mydiv-headimg1" />
							<router-link to="/Collection">
								<p class="Usercenter-mydiv-headp1" :style="hh('/Collection')">收藏夹</p>
							</router-link>
						</div>
						<div class="Usercenter-mydiv-head1">
							<img src="../../img/pinglun.png" alt class="Usercenter-mydiv-headimg1" />
							<router-link to="/comment">
								<p class="Usercenter-mydiv-headp1" :style="hh('/comment')">我的评论</p>
							</router-link>
						</div>
						<div class="Usercenter-mydiv-head1">
							<img src="../../img/tongzhi.png" alt class="Usercenter-mydiv-headimg1" />
							<router-link to="/noticeone">
								<p class="Usercenter-mydiv-headp1" :style="hh('/noticeone')">站内通知</p>
							</router-link>
						</div>
						<div class="Usercenter-mydiv-head1">
							<img src="../../img/guanzhu.png" alt class="Usercenter-mydiv-headimg1" />
							<router-link to="/follow">
								<p class="Usercenter-mydiv-headp1" :style="hh('/follow')">关注的人</p>
							</router-link>
						</div>
						<!-- <div class="Usercenter-mydiv-head1">
              <img src="../../img/fans.png" alt class="Usercenter-mydiv-headimg1" />
              <router-link to="/fans">
                <p class="Usercenter-mydiv-headp1" :style="hh('/fans')">我的粉丝</p>
              </router-link>
						</div>-->
					</div>
				</div>
			</div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Fotter from "../Fotter.vue";
	import loginheader from "../loginheader.vue";
	export default {
		name: "App",
		components: {
			Fotter,
			loginheader
		},
		data() {
			return {};
		},
		methods: {
			open(a) {
				this.$prompt(a, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消"
				})
					.then(({ value }) => {
						this.$message({
							type: "success",
							message: "修改成功：" + value
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "取消输入"
						});
					});
			},
			hh(path) {
				if (this.$route.path == path) {
					return "color:#25BFD0";
				}
			}
		},
		mounted() {
			console.log(this.$route.path);
		}
	};
</script>
<style scoped="scoped">
	.chang {
		color: #25bfd0;
	}
	.Usercenter {
		position: relative;
	}

	.Usercenter-bg {
		width: 100%;
		height: 120px;
		position: absolute;
		top: 40px;
	}

	.Usercenter-img {
		width: 100%;
		height: 120px;
	}

	.Usercenter-concent {
		margin-top: 110px;
		width: 100%;
		display: flex;
		justify-content: center;
		background-color: #f5f5f5;
	}

	.Usercenter-con {
		width: 1200px;
		height: auto;
		z-index: 100;
		display: flex;
		margin-bottom: 40px;
	}

	.Usercenter-con-left {
		width: 900px;
		border-radius: 6px;
		margin-right: 80px;
	}

	.Usercenter-con-right {
		width: 220px;
		height: 372px;
		border-radius: 6px;
		border: 1px solid #e6e6e6;
		padding: 20px 16px;
		background-color: #fff;
		box-sizing: border-box;
	}
	.Usercenter-myp {
		font-size: 18px;
		font-weight: bold;
	}
	.Usercenter-mydiv {
		width: 188px;
		height: 290px;
		border: 1px solid #ccc;
		border-radius: 8px;
		margin-top: 10px;
		box-sizing: border-box;
	}
	.Usercenter-mydiv-head {
		width: 186px;
		height: 50px;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		background-color: #25bfd0;
		padding-left: 17px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
	}
	.Usercenter-mydiv-head1 {
		width: 186px;
		height: 45px;
		padding-left: 17px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
	}
	.Usercenter-mydiv-headimg {
		width: 22px;
		height: 24px;
		background-color: #25bfd0;
		margin-right: 16px;
	}
	.Usercenter-mydiv-headimg1 {
		width: 24px;
		height: 24px;
		margin-right: 16px;
	}
	.Usercenter-mydiv-headp {
		font-size: 16px;
		color: #fff;
	}
	.Usercenter-mydiv-headp1 {
		font-size: 16px;
		color: #212121;
	}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/Usercenter.vue